









































import {
  SfList,
} from '@storefront-ui/vue'
import DsbOrderListItem from '~/modules/customer/components/Orders/DsbOrderListItem.vue'
import DsbConfirmationModal from "~/components/Modal/DsbConfirmationModal.vue";
import DsbNotification from '~/components/DsbNotification.vue'
import useOrderCancellation from "~/modules/customer/composables/useOrderCancellation";
import {computed, ref} from "@nuxtjs/composition-api";

export default {
  name: 'CancelOrderModal',
  components: {
    DsbOrderListItem,
    SfList,
    DsbConfirmationModal,
    DsbNotification
  },
  props: {
    orderItems: {
      type: Array,
      default: []
    },
    orderId: {
      type: String,
      default: ''
    },
    showModal: {
      type: Boolean,
      default: false
    },
  },
  emits: ['close'],
  setup(props, {emit}) {
    const {cancelOrder} = useOrderCancellation()

    const confirmCancelOrderModal = ref({
      title: "Möchten Sie die folgende Bestellung wirklich stornieren?",
      subline: "Folgende Produkte aus Ihrer Bestellung wurden noch nicht versendet und können von Ihnen storniert werden: ",
      agreeButtonText: "Stornierung bestätigen",
      cancelButtonText: "Stornierung abbrechen",
    })

    const isVisibleNotification = ref(false)

    const notification = ref({
      title: '',
      message: '',
      notificationType: '',
    })

    const confirmHandler = async () => {
      const result = await cancelOrder(props.orderId)

      if (result.requestOrderCancellation.success) {
        notification.value = {
          title: '',
          message: result.requestOrderCancellation.message,
          notificationType: 'success',
        }
      } else {
        notification.value = {
          title: 'Es ist ein Fehler aufgetreten!',
          message: result.requestOrderCancellation.message,
          notificationType: 'error',
        }
      }

      isVisibleNotification.value = true
      props.showModal = false
    }

    const closeHandler = () => {
      emit('close', false)
    }

    const isModalVisible = computed(() => {
      return props.showModal
    })


    return {
      confirmCancelOrderModal,
      isModalVisible,
      isVisibleNotification,
      notification,
      closeHandler,
      confirmHandler
    }
  },
}
